export default __webpack_public_path__ + "00dc4bcd1890f53f887d0c7a649f74f5.png";